import React, { useEffect } from "react";
import { NavLink, Link } from "react-router-dom";
import {
	MdClose,
	MdHome,
	MdApartment,
	MdHouse,
	MdSchool,
	MdHelpOutline,
	MdSupportAgent,
	MdLogout,
	MdLogin,
	MdChevronRight,
} from "react-icons/md";
import LogoApp from "../../images/kosass.png";
import oidcAuthService from "../../services/OidcAuthService";

const icons = {
	"/": <MdHome />,
	"/hostels": <MdApartment />,
	"/homestels": <MdHouse />,
	"/obuasi-campus": <MdSchool />,
	"/faqs": <MdHelpOutline />,
	"/help-desk": <MdSupportAgent />,
};

const links = [
	{ to: "/", label: "Home", end: true },
	{ to: "/hostels", label: "Hostels" },
	{ to: "/homestels", label: "Homestels" },
	{ to: "/obuasi-campus", label: "Obuasi Campus" },
	{ to: "/faqs", label: "FAQs" },
	{ to: "/help-desk", label: "Help Desk" },
];

// Mobile slide-in menu for the public site.
export default function Drawer(props) {
	const { setDrawer, isDrawerOpen, user, initial, onLogout } = props;
	const close = () => setDrawer(false);

	useEffect(() => {
		if (!isDrawerOpen) return;
		const onKey = (e) => e.key === "Escape" && setDrawer(false);
		document.addEventListener("keydown", onKey);
		const prev = document.body.style.overflow;
		document.body.style.overflow = "hidden";
		return () => {
			document.removeEventListener("keydown", onKey);
			document.body.style.overflow = prev;
		};
	}, [isDrawerOpen, setDrawer]);

	return (
		<div className={`pn-drawer${isDrawerOpen ? " is-open" : ""}`} aria-hidden={!isDrawerOpen}>
			<div className="pn-backdrop" onClick={close} />
			<aside className="pn-drawer-panel" role="dialog" aria-modal="true" aria-label="Menu">
				<div className="pn-drawer-head">
					<Link to="/" onClick={close} className="pn-logo">
						<img src={LogoApp} alt="KOSASS" />
					</Link>
					<button type="button" className="pn-drawer-close" onClick={close} aria-label="Close menu">
						<MdClose />
					</button>
				</div>

				<ul className="pn-drawer-links">
					{links.map((link) => (
						<li key={link.to}>
							<NavLink
								to={link.to}
								end={link.end}
								onClick={close}
								tabIndex={isDrawerOpen ? 0 : -1}
								className={({ isActive }) => `pn-drawer-link${isActive ? " is-active" : ""}`}
							>
								<span className="pn-drawer-icon">{icons[link.to]}</span>
								{link.label}
								<MdChevronRight className="pn-drawer-chevron" />
							</NavLink>
						</li>
					))}
				</ul>

				<div className="pn-drawer-foot">
					{user ? (
						<>
							<div className="pn-drawer-user">
								<span className="pn-avatar pn-avatar--lg">{initial}</span>
								<div>
									<b>{user?.name || "Signed in"}</b>
									{user?.email && <small>{user.email}</small>}
								</div>
							</div>
							<button type="button" className="pn-drawer-btn pn-drawer-btn--ghost" onClick={onLogout}>
								<MdLogout /> Sign Out
							</button>
						</>
					) : (
						<button
							type="button"
							className="pn-drawer-btn"
							onClick={() => {
								close();
								oidcAuthService.login();
							}}
						>
							<MdLogin /> Login
						</button>
					)}
				</div>
			</aside>
		</div>
	);
}
